import "./RecipeList.css";
import FilterList from "./FilterList";
import Recipe from "./Recipe.js";
import React, { useMemo, useState } from "react";
const RecipeList = (props) => {
  const originalRecipes = props.recipes;
  const changeSidebarState = props.changeSidebarState;
  const changeSelectedItem = props.changeSelectedItem;
  const selectedItems = props.selectedItems || [];
  const [searchBarText, setSearchBarText] = useState("");
  const [filterBarText, setFilterBarText] = useState("All");

  const recipes = useMemo(() => {
    const recipeSource = originalRecipes || [];
    if (!filterBarText) {
      return recipeSource;
    }

    return recipeSource.filter((recipe) => {
      if (filterBarText === "All") {
        return recipe.Name.toLowerCase().includes(searchBarText.toLowerCase());
      } else {
        if (!searchBarText) {
          return recipe.Type === filterBarText;
        } else {
          return (
            recipe.Name.toLowerCase().includes(searchBarText.toLowerCase()) &&
            recipe.Type === filterBarText
          );
        }
      }
    });
  }, [filterBarText, originalRecipes, searchBarText]);

  return (
    <div>
      <FilterList
        searchBarText={searchBarText}
        changeText={setSearchBarText}
        changeFilter={setFilterBarText}
        filterBarText={filterBarText}
        changeSidebarState={changeSidebarState}
      />

      <div className="recipe-wrapper">
        {recipes.map((recipe) => {
          return (
            <Recipe
              changeSelectedItem={changeSelectedItem}
              isSelected={selectedItems.some((item) => item.Name === recipe.Name)}
              key={recipe.Name}
              recipe={recipe}
            ></Recipe>
          );
        })}
      </div>
    </div>
  );
};
export default RecipeList;
